import { useEffect } from "react";
import { useTheme } from "@/context/ThemeContext";
import { isNativeCapacitorApp } from "@/integrations/clients/carAuction/nativeAuth";
import {
  configureNativeKeyboard,
  configureNativeStatusBar,
} from "@/lib/native/capacitorBridge";

/** Status bar, keyboard, and `bilenia-native-app` html class for Capacitor. */
export function useNativeCapacitorSetup() {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  useEffect(() => {
    if (!isNativeCapacitorApp()) return;
    document.documentElement.classList.add("bilenia-native-app");
    void configureNativeKeyboard();
  }, []);

  useEffect(() => {
    if (!isNativeCapacitorApp()) return;
    void configureNativeStatusBar(isDark);
  }, [isDark]);
}
